<template>
  <div id="product_item">
    <div class="asset">
      <div
        class="asset_content"
        :style="{ 'flex-direction': shrink ? 'column' : direction}"
        v-fadeIn
      >
        <div class="thunbnail" :style="{'flex': shrink ? 'none' : '1'}">
          <div class="toggle" v-if="productInfo.thumbnailRight">
            <van-icon
                name="arrow-left"
                class="icon"
                @click="onLeft"
                :color="currentThumbnail == productInfo.thumbnailLeft ? '#9f9f9f' : '#333'"
            />
            <van-icon
                name="arrow"
                class="icon"
                @click="onRight"
                :color="currentThumbnail == productInfo.thumbnailRight ? '#9f9f9f' : '#333'"
            />
          </div>
          <div class="thumbnail_content">
            <img :src="currentThumbnail" alt="" />
          </div>
        </div>
        <div class="introduce" :style="{'width': shrink ? '65vw' : 'auto'}">
          <div class="introduce_content">
            <div class="title">{{ productInfo.title }}</div>
            <div class="sub_title">{{ productInfo.subTitle }}</div>
            <div class="button" @click="onVisible">
                <span>{{ $t("product.BUTTON") }}</span>
            </div>
            <PopupView v-model:visible="visible" :productInfo="productInfo"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject, onMounted, ref, defineProps, computed } from "vue";
import provide_key from "@/constant/provide_key";
import PopupView from "./PopupView.vue";

const props = defineProps(["productInfo", "reverse"])

const shrink: boolean | undefined = inject(provide_key.SHRINK);

const direction = computed(() => props.reverse ? 'row' : 'row-reverse')

const visible = ref(false)

const onVisible = () => visible.value = true

const currentThumbnail = ref(props.productInfo.thumbnailLeft)

const onLeft = () => currentThumbnail.value = props.productInfo.thumbnailLeft

const onRight = () => currentThumbnail.value = props.productInfo.thumbnailRight
</script>

<style lang="less" scoped>
#product_item {
    width: calc(var(--view-max-width) + 1rem);
  .asset {
    width: 100%;

    &_content {
      max-width: var(--view-max-width);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      margin: 0 auto;
      position: relative;
      gap: 2rem;
    }

    .thunbnail {
      height: 30rem;
      width: 30rem;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      .toggle {
        display: flex;
        width: 100%;
        position: absolute;
        bottom: 2rem;
        z-index: 3;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icon {
            cursor: pointer;
            font-size: 1.8rem;
        }
      }

      &:hover {
        .thumbnail_content {
          transform: scale(120%);
        }
      }

      .thumbnail_content {
        
        width: 100%;
        height: 100%;
        position: absolute;
        overflow-y: hidden;
        transition: all 0.5s;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          height: 80%;
          width: 80%;
          object-fit: contain;
        }
      }
    }

    .introduce {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;

      &_content {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        background-color: rgba(238, 238, 238, 0.1);
        border-radius: 2.5rem;
        padding: 1.5rem;
        width: fit-content;
      }


      .title {
        font-size: var(--label-title);
        font-weight: 700;
        overflow: hidden;
        line-height: 3rem;
        color: #1a45b1;
      }

      .sub_title {
        font-size: var(--label-description);
        font-weight: 400;
        color: #2e2e2e;
      }

      .button {
        background: #002fa5;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 20px;
        margin-top: 1.4rem;
        color: #fff;
        cursor: pointer;
        border-radius: 0.5rem;
        font-size: 0.8rem;
        width: 15rem;

        &:hover {
          background: #073dc4;
        }
      }


    }
  }
}
</style>